import React, { FC, forwardRef, HTMLAttributeAnchorTarget, ReactNode } from 'react';
import NextLink, { LinkProps } from 'next/link';
import styled from 'styled-components';
import { Link as NavLink } from '@sapiens/insured-component-library';

interface StyledLinkProps {
  innerRef: ReactNode;
  to?: string;
  target?: HTMLAttributeAnchorTarget;
}

const Anchor = styled(NavLink)<StyledLinkProps>`
  &:hover {
    text-decoration: none;
  }
`;

const NativeLink: FC<Partial<StyledLinkProps>> = forwardRef(({ children, ...rest }, ref) => {
  return (
    <Anchor {...rest} innerRef={ref}>
      {children}
    </Anchor>
  );
});

NativeLink.displayName = 'NativeLink';

interface NextLinkProps extends LinkProps {
  disabled?: boolean;
  target?: HTMLAttributeAnchorTarget;
}
/**
 * @name Link
 * @param href required
 * @param children required
 * @param color optional
 * @param hoverColor optional
 * @returns ReactElement
 * @example
 * <Link href="/about">
 *  <span>Go to About</span>
 * </Link>
 */
export const Link: FC<NextLinkProps> = ({ href, disabled, children, target, ...rest }) => {
  if (disabled) {
    return (
      <NativeLink data-testid="disabled-link" {...rest}>
        {children}
      </NativeLink>
    );
  }

  return (
    <NextLink {...rest} href={href} passHref>
      <NativeLink {...rest} target={target}>
        {children}
      </NativeLink>
    </NextLink>
  );
};
